import * as React from 'react';
import { LowPriority } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { Dialog, Alert, type AlertDetails } from '../../components';
import {
  ApplicationViewList,
  type ApplicationViewListProps,
  type CustomAction,
  type ApplicationViewTableDataItem,
  type FilterFields,
} from '../Application/components/ApplicationViewList';
import { useApproveRenomination } from './graphql';
import { UploadDialog } from './components';

const PAGE_TEXT = {
  CONFIRM: 'Confirm',
  CANCEL: 'Cancel',
  CONFIRM_RENOMINATE_NOTIFICATION:
    'Are you sure you want to renominate this application? ',
  CONFIRM_SUCCESS: 'Renominate the application successfully. ',
};

export const ScholarshipList: React.FunctionComponent = () => {
  const [openRenominateDialog, setOpenRenominateDialog] =
    React.useState<boolean>(false);

  const [selectedAppId, setSelectedAppId] = React.useState<string>('');
  const [openAlert, setOpenAlert] = React.useState(false);
  const [alertDetails, setAlertDetails] = React.useState<AlertDetails>({
    alertContent: '',
    alertType: 'info',
  });

  const handleOpenRenominationDialog = (
    row: ApplicationViewTableDataItem,
  ): void => {
    const { applicationId } = row;
    setOpenRenominateDialog(true);
    setSelectedAppId(applicationId);
  };
  const approveRenomination = useApproveRenomination();
  const handleApproveRenomination = async (): Promise<void> => {
    try {
      await approveRenomination({
        variables: {
          applicationId: selectedAppId,
        },
      });
      setAlertDetails({
        alertContent: PAGE_TEXT.CONFIRM_SUCCESS,
        alertType: 'success',
      });
    } catch (error) {
      setAlertDetails({
        alertContent: 'Error Occurs.' + (error as Error)?.message,
        alertType: 'error',
      });
    }
    setOpenRenominateDialog(false);
    setOpenAlert(true);
  };

  const customActions: CustomAction[] = [
    {
      icon: <LowPriority />,
      handleAction: handleOpenRenominationDialog,
      checkDisable: () => {
        return false;
      },
    },
  ];

  const hiddenFilters: FilterFields[] = React.useMemo(() => ['gsAssignee'], []);
  const filterProps: ApplicationViewListProps['filterProps'] = {
    hiddenFilterFields: hiddenFilters,
    onlyPaidApplicationStatusList: false,
  };
  const customTools = [<UploadDialog key="custom-rgc-result-update" />];

  const tableProps: ApplicationViewListProps['tableProps'] = {
    customActions,
  };

  const toolsProps: ApplicationViewListProps['toolsProps'] = {
    customTools,
  };

  return (
    <div>
      <Alert
        openAlert={openAlert}
        setOpenAlert={setOpenAlert}
        alertDetails={alertDetails}
      />
      <Dialog
        openDialog={openRenominateDialog}
        dialogTitle=""
        dialogAction={PAGE_TEXT.CONFIRM}
        cancelAction={PAGE_TEXT.CANCEL}
        onDialogAction={handleApproveRenomination}
        onDialogClose={() => {
          setOpenRenominateDialog(false);
        }}
      >
        <Typography margin={'0rem 1.5rem 2rem'}>
          {PAGE_TEXT.CONFIRM_RENOMINATE_NOTIFICATION}
        </Typography>
      </Dialog>
      <ApplicationViewList
        tableProps={tableProps}
        filterProps={filterProps}
        toolsProps={toolsProps}
      />
    </div>
  );
};
